import axios from "axios";
import { v4 as uuidv4 } from "uuid";

//custom axios interceptor for inventory portal
//paramsSerializer: (params) => parseParams(params)
function parseParams(params) {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && params[key]?.length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
}

const AxiosClient = axios.create({
  paramsSerializer: (params) => parseParams(params),
});

export const clearAxiosAuthorizationHeader = () => {
  delete AxiosClient.defaults.headers.common["Authorization"];
};

AxiosClient.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("currUserToken"));
  if (!!token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["X-Request-Id"] = uuidv4();
  }
  return config;
});

AxiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    //Access token expired
    if (error.response?.status === 403 && !originalRequest?._retry) {
      originalRequest._retry = true;
      const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
      if (localUserToken)
        axios
          .post(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
            user_id: localStorage.getItem("user_id"),
          })
          .then((res) => {
            console.log("Session expired, sigining out");
            clearAxiosAuthorizationHeader();
            localStorage.clear();
            window.location.pathname = "/signin";
          })
          .catch((err) => {
            console.log(err);
            alert("Something went wrong when trying to log out!");
          });
      else {
        console.log("Session expired, sigining out");
        clearAxiosAuthorizationHeader();
        localStorage.clear();
        window.location.pathname = "/signin";
      }
    } else if (
      error.response?.status === 500 &&
      error.response?.data &&
      error.response?.data?.message
    ) {
      console.log(error.response.data.message);
    }

    return Promise.reject(error);
  }
);

export default AxiosClient;
